module.exports = __webpack_public_path__ + "img/idCard-back.70a43bd3.png";